import Colors, { blend, withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
const sizes = {
    smallContainer: {
        width: Spacings.xxLarge,
        height: Spacings.xxLarge,
    },
    small: {
        width: Spacings.xLarge,
        height: Spacings.xLarge,
    },
    large: {
        width: Spacings.xxxxLarge,
        height: Spacings.xxxxLarge,
    },
};
const InternalAvatarTheme = {
    internalAvatar: {
        light: {
            states: {
                enabled: {
                    color: Colors.white,
                    backgroundColor: Colors.ironGrey,
                },
                disabled: {
                    color: withOpacity(Colors.black, Opacities.low),
                    backgroundColor: blend(Colors.white, Colors.black, Opacities.low),
                },
                hover: {
                    color: Colors.white,
                    backgroundColor: Colors.black,
                },
                active: {
                    color: Colors.black,
                    backgroundColor: Colors.accessibleSafetyOrange,
                },
            },
            sizes,
        },
        dark: {
            states: {
                enabled: {
                    color: Colors.white,
                    backgroundColor: Colors.ironGrey,
                },
                disabled: {
                    color: withOpacity(Colors.white, Opacities.low),
                    backgroundColor: blend(Colors.black, Colors.white, Opacities.xLow),
                },
                hover: {
                    color: Colors.black,
                    backgroundColor: Colors.white,
                },
                active: {
                    color: Colors.black,
                    backgroundColor: Colors.accessibleSafetyOrange,
                },
            },
        },
    },
};
export default InternalAvatarTheme;
